import { inject, Injectable } from '@angular/core';
import { HttpClientWrapper } from './http-client-wrapper.service';
import { Observable } from 'rxjs';
import { MfaUserProfileModel } from '../models/user-profile.model';

@Injectable({
  providedIn: 'root',
})
export class MfaService {
  private httpWrapper = inject(HttpClientWrapper);

  authenticateMfaCode(
    code: string,
    rememberUser: boolean,
  ): Observable<MfaUserProfileModel> {
    return this.httpWrapper.post(
      '/auth/challenge/totp',
      {},
      {
        code,
        twoFactorDelay: rememberUser,
      },
    );
  }

  getMfaSetupCode(): Observable<{ key: string; qrCodeUrl: string }> {
    return this.httpWrapper.get('/auth/enable-2fa', {});
  }

  setUpMfa(code: string): Observable<any> {
    return this.httpWrapper.post('/auth/enable-2fa', { code }, {});
  }

  getIsMfaEnabled(mfaToken: string): Observable<MfaUserProfileModel> {
    return this.httpWrapper.post('/auth/mfa', { mfaToken }, {});
  }

  resendEmailCode(): Observable<any> {
    return this.httpWrapper.post('/auth/resend-2fa-code', {}, {});
  }

  sendSetUpEmailCode(): Observable<any> {
    return this.httpWrapper.post('/auth/enable-2fa-email/send', {}, {});
  }

  setUpEmailMfa(code: string): Observable<any> {
    return this.httpWrapper.post('/auth/enable-2fa-email/verify', { code }, {});
  }
}
